import { DefaultContext } from "@apollo/client";
import { ShopifyGraphqlApiVersion } from "@intelligems/ig-types";

type ApolloContextCarrier = {
  context?: DefaultContext;
};

export function withShopifyGraphqlVersion<TOptions extends object>(
  options: TOptions & ApolloContextCarrier,
  version: ShopifyGraphqlApiVersion
): TOptions & {
  context: DefaultContext;
} {
  return {
    ...options,
    context: {
      ...options.context,
      shopifyApiVersion: version,
    },
  };
}

export function withUnstableShopifyGraphqlVersion<TOptions extends object>(
  options: TOptions & ApolloContextCarrier
): TOptions & {
  context: DefaultContext;
} {
  return withShopifyGraphqlVersion(options, "unstable");
}
